import { useState } from 'react';
import { LogOut, AlertTriangle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';

export default function AccountTab() {
  const { user, signOut } = useAuth();
  const { workspace } = useWorkspace();
  const [showDangerZone, setShowDangerZone] = useState(false);

  return (
    <div className="space-y-8">
      {/* Profile */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Profile</h3>
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-6">
          <div className="flex items-center gap-4 mb-6">
            {user?.image ? (
              <img src={user.image} alt="" className="w-16 h-16 rounded-full" />
            ) : (
              <div className="w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-600 dark:text-blue-400 text-xl font-bold">
                {(user?.name || user?.email || '?')[0].toUpperCase()}
              </div>
            )}
            <div>
              <p className="text-lg font-semibold text-gray-900 dark:text-white">
                {user?.name || 'No name set'}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400">{user?.email}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
                Email
              </label>
              <p className="text-sm text-gray-900 dark:text-white">{user?.email || '—'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
                Account ID
              </label>
              <p className="text-xs font-mono text-gray-500 dark:text-gray-400">{user?.id || '—'}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Workspace */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Workspace</h3>
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Workspace Name
            </label>
            <p className="text-sm text-gray-900 dark:text-white">{workspace?.name || '—'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Workspace ID
            </label>
            <p className="text-xs font-mono text-gray-500 dark:text-gray-400 select-all">{workspace?.id || '—'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Created
            </label>
            <p className="text-sm text-gray-900 dark:text-white">
              {workspace?.createdAt ? new Date(workspace.createdAt).toLocaleDateString() : '—'}
            </p>
          </div>
        </div>
      </div>

      {/* Sign Out */}
      <div>
        <button
          onClick={signOut}
          className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 text-sm font-medium transition"
        >
          <LogOut size={16} />
          Sign Out
        </button>
      </div>

      {/* Danger Zone */}
      <div>
        <button
          onClick={() => setShowDangerZone(!showDangerZone)}
          className="text-sm text-gray-400 hover:text-red-500 transition"
        >
          {showDangerZone ? 'Hide' : 'Show'} danger zone
        </button>

        {showDangerZone && (
          <div className="mt-3 border border-red-200 dark:border-red-800 rounded-xl p-4 bg-red-50 dark:bg-red-900/10">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle size={16} className="text-red-500" />
              <h4 className="text-sm font-semibold text-red-700 dark:text-red-400">Danger Zone</h4>
            </div>
            <p className="text-sm text-red-600 dark:text-red-400 mb-3">
              Deleting your workspace will permanently remove all products, templates, fonts, and history. This cannot be undone.
            </p>
            <button
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition"
              onClick={() => alert('Contact support to delete your workspace.')}
            >
              Delete Workspace
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
